<template>
    <div>
        <TextBanner>
        In der Nacht zum <strong>26.04.1986</strong> kommt es zur <strong>Kernschmelze</strong> und zu <strong>zwei Explosionen</strong> im sowjetischen Kernkraftwerk Tschernobyl. Der Block wird vollständig zerstört.
        </TextBanner>
        

        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/02_Explosion_iPad_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/02_Explosion_iPad_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <!--<img class="o-fit o-fit--cover" src="../assets/img/fallback/TextBanner.jpg" alt="">-->
                <img class="o-fit o-fit--cover" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt="">
            </picture>
        </Fallback>
    </div>
</template>

<script>
    export default {
        name: 'Explosion',
        
        babylonState: {
            moveCamera: [-7.4, 1.5, 15, 13, 1.5, 0],
        
            //Promo Camera Position
            //moveCamera: [-7.2, .9, 12, 13.5, 3, -1.5],


            Geo_Explosion: true,
    
            explosion: true,

            Geo_Tschernobyl: {
                children: {

                    BG_Sphere: true,

                    Geo_Textur1_Reaktor_4_unversehrt: false,
                    Geo_Textur1_Reaktor_4_Damage: true,
                    Geo_Textur1_Reaktor_4_Damage_Aussen: true,
                    Geo_Textur1_Reaktor_4_Damage_Innen: true,
                    Geo_Neuer_Sarkophag_still: {
                        visible:false,
                        fade: true
                    },
                    Geo_Typo_1: false,
                    Geo_Typo_2: false,
                    Geo_Typo_3: false,
                    Geo_Typo_4: false,
                    Geo_Typo_Reaktor: false,
                    Geo_Typo_1986_Oben: false,

                    Geo_Typo_1986_Mitte: false,
                    
                    Geo_KleinerTurm_Geruest1: false,
                    Geo_KleinerTurm_RoteStreifen1: false,
                    Geo_KleinerTurm_Schlot1: false,
                    Geo_KleinerTurm_Schattenplane: false,
                    
                    Geo_GrosserTurm_Gestaenge1: true,
                    Geo_GrosserTurm_Schlot1: true,
                    Geo_GrosserTurm_RoteStreifen1: true,
                    Geo_GrosserTurm_Schattenplane: true,

                    
                }
            },

            fire: false,
        },

        
        babylonReady: function () {
            

            //this.$audioController.initTrack('speaker', require('./../assets/audio/Uebergang_01.mp3'), false, true);
            
            this.$babylonController.startAnimation("Explosion",false,1),  

            this.$babylonController.setCameraRadiusLimit (5,40),
            this.$babylonController.zoomCamera(0.8)

            // Promo
            //this.$babylonController.zoomCamera(0.9)
            
        },


    }
</script>

<style lang="scss">

</style>